import type { QueryClient } from "@tanstack/react-query";

// Todas las queries que leen de spray_logs / spray_log_entries /
// inventory_transactions de tratamientos. Antes de este helper, crear, editar
// o borrar un registro de aplicación solo invalidaba un puñado de claves y el
// resto de analíticas quedaba obsoleto hasta el staleTime (5 min) o un
// remontaje. Prefijos: invalidateQueries hace match parcial por prefijo.
const TREATMENT_DATA_QUERY_KEYS: string[] = [
  // Página de registros
  "spray-log-metrics",
  "spray-log-by-id",
  // Dashboard
  "dashboard-cost-metrics",
  "biological-vs-chemical",
  "weekly-treatments",
  "at-risk-products",
  "greenhouse-ipm-scores",
  "farm-health-map",
  // Analíticas
  "kpi-metrics",
  "treatment-mode-costs",
  "greenhouse-costs",
  "crop-costs-spray",
  "pest-treatments",
  "flexible-cost-trend",
  "activity-summary",
  "block-cost-m2",
  "bio-vs-chemical-counts",
  "treatments-by-block",
  "treatments-by-worker",
  "product-applications",
  "irm-overview",
  // Sector / invernadero
  "block-cost-metrics",
  "greenhouse-cost-metrics",
  "block-phi-status",
  "block-phi-status-single",
  // Ciclos y campañas
  "attributed-spray-log-ids",
  "campaign-cycle-report",
  "cycle-compare-metrics",
  "closed-cycle-summary",
  // Informes / inventario
  "consumption-report-v2",
  "inventory-register",
];

/**
 * Invalida todo lo que depende de los registros de aplicación. Llamar tras
 * crear, editar o borrar un spray log (manual o vía tarea).
 */
export function invalidateTreatmentData(queryClient: QueryClient) {
  for (const key of TREATMENT_DATA_QUERY_KEYS) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
